<template>
  <div class="message">
    <div class="message-input">
      <div style="padding-top: 20px;">
        <el-input
          type="textarea"
          :rows="5"
          placeholder="请输入留言"
          resize="none"
          v-model="textarea">
        </el-input>
      </div>
      <div style="text-align: right; padding: 20px 0;">
        <el-button type="primary" round @click="handleAdd">发表留言</el-button>
      </div>
    </div>

    <div class="message-title">
      <h3>留言：</h3>
    </div>
    <div class="message-content">
      <template v-for="(item, index) in list">
        <div :key="index" class="msg-cad">
          <div class="card-top">
            <div class="card-user">
              <img :src="require('../assets/u_img/' + item.u_img)" alt="">
              <span>{{item.u_name}}</span>
            </div>
            <div class="card-time">{{item.message_tiem | formatTime('yy-mm-dd hh:mm:ss')}}</div>
          </div>
          <div class="card-middle">
            <p>{{item.content}}</p>
            <div v-if="item.children.length > 0" class="comment-card">
              <template v-for="(children, i) in item.children">
                <div :key="i" class="comment-list">
                  <p v-if="children.u_id == children.uu_id">
                    <span style="color: #13227A; cursor: pointer;" @click="handleCommentList(children.u_name, children.u_id, i, item, index)">{{children.u_name ? children.u_name : '无名'}}</span>
                    <span>：{{children.pcontent}}</span>
                  </p>
                  <p v-else>
                    <span style="color: #13227A; cursor: pointer;" @click="handleCommentList(children.uu_name, children.uu_id, i, item, index)">{{children.uu_name ? children.uu_name : '无名'}}</span>
                    <span>回复</span>
                    <span style="color: #13227A; cursor: pointer;" @click="handleCommentList(children.u_name, children.u_id, i, item, index)">{{children.u_name ? children.u_name : '无名'}}</span>
                    <span>：{{children.pcontent}}</span>
                  </p>
                </div>
              </template>
            </div>
          </div>
          <div class="card-bottom">
            <span class="bottom-operation" @click="handleComment(item, index)">
              <img src="../assets/msg.png" alt="">
              <span>{{item.isShow ? '取消评论' : '评论'}}</span>
            </span>
            <span class="bottom-operation" @click="handleZan(item, index)" v-show="!item.is_praise">
              <img src="../assets/zan0.png" alt="">
              <span>点赞 {{item.praise > 0 ? item.praise : ''}}</span>
            </span>
            <span class="bottom-operation" @click="handleZan1(item, index)" v-show="item.is_praise">
              <img src="../assets/zan1.png" alt="">
              <span style="color: #13227A;">已赞 {{item.praise > 0 ? item.praise : ''}}</span>
            </span>
          </div>
          <el-collapse-transition>
            <div class="comment-input" v-show="item.isShow">
              <div style="padding-top: 20px;">
                <el-input
                  type="textarea"
                  :rows="5"
                  :placeholder="placeholder"
                  resize="none"
                  v-model="item.comment">
                </el-input>
              </div>
              <div style="text-align: right; padding-top: 20px;">
                <el-button type="primary" round @click="handleAddComment(item, index)">发表评论</el-button>
              </div>
            </div>
          </el-collapse-transition>
        </div>
      </template>
    </div>
    <div style="text-align: center;">
      <span v-show="list.length > 0 && page < pageCount" style="cursor: pointer; padding: 20px 0; display: inline-block;" @click="handleLoad">点击加载更多···</span>
      <span v-show="list.length > 0 && page >= pageCount" style="color: #e78f0b; padding: 20px 0; display: inline-block;">我是有底线的···</span>
      <span v-show="list.length < 1" style="padding: 100px 0; display: inline-block; font-size: 50px;">暂无数据···</span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'message', //留言
    metaInfo () {
      return {
        title:'留言'
      }
    },

    data () {
      return {
        isClick: true,
        list: [],
        page: 1,
        count: 0,
        pageCount: 0,
        textarea: '',
        userInfo: '',
        placeholder: '发表你的评论',
        u_id: '',
        uu_id: '',
        u_name: '',
        uu_name: ''
      }
    },

    mounted () {
      let userInfo = localStorage.getItem('userInfo')
      if(typeof userInfo === 'string' && (userInfo !== undefined || userInfo !== 'undefined')) {
        let jsonStr = window.decodeURIComponent(window.atob(userInfo))
        try {
          this.userInfo = JSON.parse(jsonStr)
        } catch (err) {}
      }
      this.getList(this.page)
    },

    methods: {
      handleAdd () {
        let userInfo = this.userInfo
        if(!userInfo) {
          this.$router.push('/user_login')
          this.$message.warning('请先登录！')
          return false
        }
        if(!this.textarea.replace(/\s*/g, "")) {
          this.$message.warning('请输入内容！')
          return false
        }
        if(!this.isClick) return false
        this.isClick = false
        let time = new Date().getTime()
        let obj = {u_id: userInfo.id, content: this.textarea, email: userInfo.email, message_tiem: time}
        this.$http.post('article/add_msg', {obj: window.btoa(window.encodeURIComponent(JSON.stringify(obj)))}, true).then(res => {
          this.isClick = true
          if(res.data.code == 0){
            let comment = JSON.parse(window.decodeURIComponent(window.atob(res.data.obj)))
            let obj1 = {children: [], comment: '', content: this.textarea, id: comment.id, isShow: false, is_praise: 0, message_tiem: time, praise: 0, u_id: userInfo.id, u_img: userInfo.u_img, u_name: userInfo.u_name}
            this.list.unshift(obj1)
            this.textarea = ''
            this.$message.success(res.data.msg)
          } else if(res.data.code == 5){
            this.$message.warning(res.data.msg)
            this.$router.push('/user_login')
          } else {
            this.$message.warning(res.data.msg)
          }
        }).catch(err => {
          this.isClick = true
          this.$message.error('网络有误！')
        })
      },

      getList (page) {
        let userInfo = this.userInfo
        this.$http.get('article/content', {obj: window.btoa(window.encodeURIComponent(JSON.stringify({u_id: userInfo ? userInfo.id : '', page: page})))}, true).then(res => {
          if(res.data.code == 0){
            let obj = JSON.parse(window.decodeURIComponent(window.atob(res.data.data)))
            if(page == 1) {
              this.list = obj.products
            } else {
              this.list = this.list.concat(obj.products)
            }
            this.pageCount = obj.pageCount
            this.count = obj.count
            this.page = parseInt(obj.page)
          } else {
            this.$message.warning(res.data.msg)
          }
        }).catch(err => {
          this.$message.error('网络有误！')
        })
      },

      handleLoad () {
        this.getList(this.page + 1)
      },

      handleComment (item, i) {
        let userInfo = this.userInfo
        if(userInfo) {
          this.u_id = userInfo.id
          this.uu_id = userInfo.id
          this.u_name = userInfo.u_name
          this.uu_name = userInfo.u_name
        }
        this.list.forEach((v, index) => {
          if(i == index) v.isShow = !v.isShow
          else v.isShow = false
        })
      },

      handleCommentList (name, id, i, item, ind) {
        let userInfo = this.userInfo
        if(userInfo) {
          this.uu_id = userInfo.id
          this.uu_name = userInfo.u_name
        }
        this.u_id = id
        this.u_name = name
        this.list.forEach((v, index) => {
          if(ind == index) v.isShow = !v.isShow
          else v.isShow = false
        })
      },

      handleAddComment (item, i) {
        let userInfo = this.userInfo
        if(!userInfo) {
          this.$router.push('/user_login')
          this.$message.warning('请先登录！')
          return false
        }
        if(!this.list[i].comment.replace(/\s*/g, "")) {
          this.$message.warning('请输入内容！')
          return false
        }
        if(!this.isClick) return false
        this.isClick = false
        let time = new Date().getTime()
        let obj = {u_id: this.u_id, uu_id: this.uu_id, pcontent: this.list[i].comment, content_id: item.id, email: userInfo.email, ptime: time}
        this.$http.post('article/add_comment', {obj: window.btoa(window.encodeURIComponent(JSON.stringify(obj)))}, true).then(res => {
          this.isClick = true
          if(res.data.code == 0){
            let comment = {u_id: this.u_id, uu_id: this.uu_id, pcontent: this.list[i].comment,  u_name: this.u_name, uu_name: this.uu_name}
            this.list[i].children.push(comment)
            this.list[i].comment = ''
            this.list[i].isShow = false
            this.$message.success(res.data.msg)
          } else if(res.data.code == 5){
            this.$message.warning(res.data.msg)
            this.$router.push('/user_login')
          } else {
            this.$message.warning(res.data.msg)
          }
        }).catch(err => {
          this.isClick = true
          this.$message.error('网络有误！')
        })
      },

      handleZan (item, i) {
        let userInfo = this.userInfo
        if(!userInfo) {
          this.$router.push('/user_login')
          this.$message.warning('请先登录！')
          return false
        }
        if(!this.isClick) return false
        this.isClick = false
        this.$http.post('article/add_praise', {obj: window.btoa(window.encodeURIComponent(JSON.stringify({u_id: userInfo.id, email: userInfo.email, content_id: item.id})))}, true).then(res => {
          this.isClick = true
          if(res.data.code == 0){
            this.$message.success(res.data.msg)
            this.list[i].is_praise = 1
            this.list[i].praise = parseInt(this.list[i].praise) + 1
          } else if(res.data.code == 5){
            this.$message.warning(res.data.msg)
            this.$router.push('/user_login')
          } else {
            this.$message.warning(res.data.msg)
          }
        }).catch(err => {
          this.isClick = true
          this.$message.error('网络有误！')
        })
      },

      handleZan1 (item, i) {
        let userInfo = this.userInfo
        if(!userInfo) {
          this.$router.push('/user_login')
          this.$message.warning('请先登录！')
          return false
        }
        if(!this.isClick) return false
        this.isClick = false
        this.$http.post('article/cancel_praise', {obj: window.btoa(window.encodeURIComponent(JSON.stringify({u_id: userInfo.id, email: userInfo.email, content_id: item.id})))}, true).then(res => {
          this.isClick = true
          if(res.data.code == 0){
            this.$message.success(res.data.msg)
            this.list[i].is_praise = 0
            this.list[i].praise = parseInt(this.list[i].praise) - 1
          } else if(res.data.code == 5){
            this.$message.warning(res.data.msg)
            this.$router.push('/user_login')
          } else {
            this.$message.warning(res.data.msg)
          }
        }).catch(err => {
          this.isClick = true
          this.$message.error('网络有误！')
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .message {
    .message-input {
      box-sizing: border-box;
      width: 95%;
      margin: auto;
    }

    .message-title {
      border-bottom: 3px solid #0e4dc0;
      padding: 10px 0;
    }

    .message-content {
      .msg-cad {
        background-color: #fff;
        padding: 25px 20px;
        margin: 10px 0;
        box-shadow: 0px 0px 5px 0px #dfe08d;
        border-radius: 10px;

        .card-top {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .card-user {
            color: rgb(16, 58, 148);

            img {
              width: 50px;
              height: 50px;
              border-radius: 50%;
              vertical-align: middle;
              margin-right: 10px;
            }
          }
        }

        .card-middle {
          padding: 20px 0;
          padding-left: 60px;

          .comment-card {
            background-color: #eee;
            border-radius: 5px;
            padding: 10px 20px;
            box-sizing: border-box;
            margin-top: 10px;

            .comment-list {
              
            }
          }
        }

        .card-bottom {
          display: flex;
          justify-content: flex-end;

          .bottom-operation:hover {
            color: #c00e0e;
          }

          .bottom-operation {
            display: flex;
            align-items: center;
            margin-left: 10px;
            cursor: pointer;

            img {
              width: 20px;
              height: 20px;
              vertical-align: middle;
              margin-right: 2px;
            }
          }
        }

        .comment-input {
          margin-left: 60px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/message.vue